<div class="verticalFlex background align-items-center ">

  <div class="panel">
    <app-branding-header
      [headerImage]="loaService.getBrandHeaderImage(brandDetails)"
      [primaryColor]="loaService.getBrandPrimaryColour(brandDetails)"
      [isRenewal]="isRenewal"
    ></app-branding-header>

    <div class="pt-4">
      <app-info-box [currentStage]="'data'" [brandColour]="loaService.getBrandPrimaryColour(brandDetails)" [isRenewal]="isRenewal"></app-info-box>
    </div>

    <div class="d-flex align-items-center justify-content-center py-3">
      <fa-icon class="timerIcon" [icon]="['fas', 'hourglass-half']"></fa-icon>
      <div class="details">Your details are being reviewed for approval.</div>
    </div>


    @if (pdfFile) {
      <div class="d-flex align-items-center justify-content-center mt-3">
        <button class="d-flex px-3 py-2 brandButton border-0"
                [style.background]="'#676767'"
                (click)="downloadPdf()">
          <fa-icon class="whiteColour pe-2" [icon]="['fas', 'download']"></fa-icon>
          <div class="whiteColour brandButtonFont">Save a copy of the LoA</div>
        </button>
      </div>

      <div class="pdf-preview mt-3">
<!--        <embed [src]="safePdfUrl" type="application/pdf" class="pdf-embed">-->
        <iframe class="pdf-embed" [src]="safePdfUrl"></iframe>
      </div>
    }

    <div class="description pt-3 d-flex align-items-center justify-content-center" [style.color]="loaService.getBrandPrimaryColour(brandDetails)">
      @if (isRenewal) {
        Take a look at your Energy Data now
      } @else {
        Your energy data will be available shortly, check back soon!
      }
    </div>

    <div class="d-flex align-items-center justify-content-center mt-3">
      <a class="d-flex px-3 my-1 py-2 brandButton text-decoration-none"
         [style.background]="loaService.getBrandPrimaryColour(brandDetails)"
         [href]="loginLink"
         target="_blank"
         rel="noopener noreferrer">
        <div class="px-4 whiteColour brandButtonFont">Login</div>
      </a>
    </div>

  </div>
  <app-footer class="py-2"></app-footer>
</div>
